var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { tagAnatomy } from "@chakra-ui/anatomy";
import { cgx } from "@springcare/dsm";
import { isVerdantColorScheme } from "../../utils/guards";
export var tagTheme = {
    parts: tagAnatomy.keys,
    baseStyle: {
        container: {
            alignItems: "center",
        },
    },
    variants: {
        "v-medium-emphasis": function (_a) {
            var colorScheme = _a.colorScheme;
            if (isVerdantColorScheme(colorScheme))
                return {
                    container: {
                        background: "".concat(colorScheme, "-subtle"),
                        color: "".concat(colorScheme, "-on-subtle"),
                    },
                };
            return {
                container: {
                    background: "accent-subtle",
                    color: "accent-on-subtle",
                },
            };
        },
    },
    sizes: {
        "v-3xs": {
            container: __assign({ padding: "v-4", borderRadius: "v-md" }, cgx.textStyles["body-small-regular"]),
        },
    },
    defaultProps: {
        size: "v-md",
        variant: "v-medium-emphasis",
    },
};
